import { FANCLUB_RESET_DATA, FANCLUB_SET_DATA, MODAL_SHOW, MODAL_TYPE_ERROR } from "../constants/constants";
import { ERROR_HEADER, ERROR_SOMETHING_WENT_WRONG } from "../constants/copy";
import { logEvent } from "../firebase/firebase";
import { CLAIM_HISTORY_V2 } from "../routes/routes";
import { logErrorToDatabase, postToController } from "./apiActions";
import { navigateTo } from "./navigationActions";

export const submitFanclubFeedback = (questionId: string, answerText: string, answerRating: string, reference: string) => {
     return async (dispatch, getState) => {
         try {
             logEvent('SSP_submit_fanclub_feedback', {});
            await postToController(dispatch, 'SendFanclubFeedback',
                JSON.stringify({
                    sourceCode: "SSP",
                    surveyQuestionCode: questionId,
                    respondantName: getState().profile.name,
                    respondantSurname: getState().profile.surname,
                    answer: answerText,
                    rating: answerRating,
                    SourceReferenceId: reference,
                })).then(async (response) => {
                    if (response !== "Failure") {
                        await dispatch(getNextQuestion())
                    }
                    else {
                        dispatch({
                            type: MODAL_SHOW,
                            modalProps: {
                                type: MODAL_TYPE_ERROR,
                                header: ERROR_HEADER,
                                body: ERROR_SOMETHING_WENT_WRONG,
                            }
                        });
                    }
                })
        } catch (err) {
            logErrorToDatabase("Error in fanclubFeedback, Error: " + err);
        }
    }
}

export const getNextQuestion = () => {
    return async (dispatch, getState) => {
        var response = false
        var currStep = getState().fanclub.currQuestionNumber

        if ((getState().fanclub.feedbackQuestions.length - 1 > currStep)) {
            await dispatch({
                type: FANCLUB_SET_DATA, payload: {
                    currQuestionNumber: (currStep + 1),
                    currQuestion: getState().fanclub.feedbackQuestions[currStep + 1]
                }
            });
            response = true;
        }
        else {
            await dispatch({
                type: FANCLUB_SET_DATA, payload: {
                    feedbackCompleted: true,
                }
            });
            return response;
        }
    }
}

export const getPrevQuestion = () => {
    return async (dispatch, getState) => {
        var currStep = getState().fanclub.currQuestionNumber
        if ((currStep > 0)) {
            await dispatch({
                type: FANCLUB_SET_DATA, payload: {
                    currQuestionNumber: (currStep - 1),
                    currQuestion: getState().fanclub.feedbackQuestions[currStep - 1]
                }
            });
        }
        else {
            await dispatch(navigateTo(CLAIM_HISTORY_V2));
            await resetFeedback();
        }
    }
}

export const resetFeedback = () => {
    return async (dispatch, getState) => {
        await dispatch({
            type: FANCLUB_RESET_DATA
        });
        return true
    }
}